import { Trash2 } from 'lucide-react';
import { type PaymentCard, type PaymentMethodTranslations } from './types';

interface CardListProps {
  cards: PaymentCard[];
  t: PaymentMethodTranslations;
  onSetAsMain: (cardId: string) => void;
  onDeleteClick: (cardId: string) => void;
}

export function CardList({ cards, t, onSetAsMain, onDeleteClick }: CardListProps) {
  return (
    <div className="space-y-3 mb-4">
      {cards.map((card) => (
        <button
          key={card.id}
          onClick={() => !card.isDefault && onSetAsMain(card.id)}
          disabled={card.isDefault}
          className={`w-full bg-background border rounded p-3 transition-all ${
            card.isDefault
              ? 'border-primary cursor-default'
              : 'border-border hover:border-secondary hover:bg-secondary/5 cursor-pointer'
          }`}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-10 h-6 bg-foreground rounded flex items-center justify-center">
                <span className="text-background text-[10px] font-bold uppercase">
                  {card.type}
                </span>
              </div>
              <div>
                <div className="flex items-center gap-2">
                  <span className="text-foreground text-sm">
                    •••• {card.lastFour}
                  </span>
                  {card.isDefault && (
                    <span className="bg-primary text-white text-[10px] px-1.5 py-0.5 rounded">
                      {t.mainCard}
                    </span>
                  )}
                </div>
                <p className="text-muted-foreground text-xs">
                  {card.expiry}
                </p>
              </div>
            </div>

            <button
              onClick={(e) => {
                e.stopPropagation();
                onDeleteClick(card.id);
              }}
              className="text-muted-foreground hover:text-destructive p-1 transition-colors z-10"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        </button>
      ))}
    </div>
  );
}
